
import _BaseController from 'Controllers/Base/_BaseController';

import AjaxSubmit from 'FF/Models/Common/AjaxSubmit';

import 'bootstrap';

export default class extends _BaseController {

    ready() {
        super.ready();
        
        global.AjaxSubmit = new AjaxSubmit;
    }

}